<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.64119 11.3588C4.3483 11.0659 4.3483 10.591 4.64119 10.2981L10.298 4.64128C10.5909 4.34838 11.0658 4.34838 11.3587 4.64128C11.6516 4.93417 11.6516 5.40904 11.3587 5.70194L5.70185 11.3588C5.40896 11.6517 4.93408 11.6517 4.64119 11.3588Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.77854 4.70026C6.77854 4.28605 7.11433 3.95026 7.52854 3.95026L11.2998 3.95026C11.714 3.95026 12.0498 4.28605 12.0498 4.70026V8.4715C12.0498 8.88571 11.714 9.2215 11.2998 9.2215C10.8856 9.2215 10.5498 8.88571 10.5498 8.4715V5.45026L7.52854 5.45026C7.11433 5.45026 6.77854 5.11447 6.77854 4.70026Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.3332 2.16669H2.6665C2.39036 2.16669 2.1665 2.39054 2.1665 2.66669V13.3334C2.1665 13.6095 2.39036 13.8334 2.66651 13.8334H13.3332C13.6093 13.8334 13.8332 13.6095 13.8332 13.3334V2.66669C13.8332 2.39055 13.6093 2.16669 13.3332 2.16669ZM2.6665 0.666687C1.56193 0.666687 0.666504 1.56212 0.666504 2.66669V13.3334C0.666504 14.4379 1.56194 15.3334 2.66651 15.3334H13.3332C14.4377 15.3334 15.3332 14.4379 15.3332 13.3334V2.66669C15.3332 1.56212 14.4377 0.666687 13.3332 0.666687H2.6665Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'NewTabIcon',
  props: {
    width: {
      type: Number,
      default: 16,
    },
    height: {
      type: Number,
      default: 16,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
